import { IndicatorDot, IndicatorDotVariants, Tooltip } from '@talos/kyoko';
import type { MarginTradingOption } from './types';

function marginTradingIndicatorVariant(value: MarginTradingOption | null | undefined): IndicatorDotVariants {
  if (value === 'enabled') {
    return IndicatorDotVariants.Positive;
  }
  if (value === 'disabled') {
    return IndicatorDotVariants.Negative;
  }
  return IndicatorDotVariants.Default;
}

export function MarginTradingIndicatorCell({ value }: { value: MarginTradingOption | null | undefined }) {
  const tooltip = value ? `Margin trading ${value}` : 'Margin trading status unknown';
  return (
    <Tooltip tooltip={tooltip}>
      <IndicatorDot variant={marginTradingIndicatorVariant(value)} show />
    </Tooltip>
  );
}
